import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Card, Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import { getDefaultCoordinates } from '../../../utils/mapUtils/CoordinateUtils'
import { getSetting } from '../../../utils/SettingUtils'
import KML from '../../../utils/mapUtils/layers/KML'
import WMS from '../../../utils/mapUtils/layers/WMS'
import LayerDto from '../../../home/dto/LayerDto'
import Map from '../../../utils/mapUtils/Map'
import { parseNowVariableURL } from '../../../utils/UrlUtils'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import { DEFAULT_MAP_BACKGROUND } from 'carto/constants/CartoConstants'
import { getCartographyBackground } from 'utils/mapUtils/MapBackgroundsUtils'

const LayerTestPanel = ({ layers = [] }) => {
    const applicationSettings = useSelector(store => store.AdministrationReducer.applicationSettings)

    const mapConf = useMemo(() => ({
        center: [parseFloat(getSetting(applicationSettings, 'defaultMapXCoordinate')) || getDefaultCoordinates()[0],
            parseFloat(getSetting(applicationSettings, 'defaultMapYCoordinate')) || getDefaultCoordinates()[1]],
        zoom: parseFloat(getSetting(applicationSettings, 'defaultMapZoom')) || 9,
        size: 700,
    }), [applicationSettings])

    const mapBg = useApplicationSetting(DEFAULT_MAP_BACKGROUND)

    const getMap = () => {
        const displayedLayers = layers.map(l => l.type === 0 ? WMS({
            url: parseNowVariableURL(l.url, getSetting(applicationSettings, 'myMaps')),
            params: { layers: l.layer },
            layerParam: l.layer,
            opacity: l.opacity,
            visible: true,
            projection: l.projection,
        }) : KML({

            url: parseNowVariableURL(l.url, getSetting(applicationSettings, 'myMaps')),
            params: { layers: l.layer },
            layerParam: l.layer,
            opacity: l.opacity,
            visible: true,
            extractStyles: true,
        }),
        ).filter(l => l)
        const allLayers = [getCartographyBackground(mapBg)].concat(displayedLayers)
        return <Map mapConf={ mapConf } layers={ allLayers } />
    }

    return (
        <Grid container sx={{ position: 'sticky', top: 80 }}>
            <Grid size={12}>
                <Card sx={{ overflow: 'visible' }}>
                    { mapConf.size ? getMap() : <div id='sieau-map' /> }
                </Card>
            </Grid>
        </Grid>
    )
}

LayerTestPanel.propTypes = {
    layers: PropTypes.arrayOf(PropTypes.instanceOf(LayerDto)),
}

export default LayerTestPanel
